import { Company } from "components/molecules/LoyaltyProgramServiceArticle/types";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { usePatchCompanyMutation } from "redux/services/companyApi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import PopupModal from "components/molecules/PopupModal/PopupModal";
import { useNavigate } from "react-router-dom";
import { NAV_PATH } from "components/organisms/Navigation/navigationData";

interface Props {
  data: Company;
}

const DeleteCompanyButton = ({ data }: Props) => {
  const [showModalDelete, setShowModalDelete] = useState(false);

  const [patchCompany] = usePatchCompanyMutation();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const modalDeleteHandler = async () => {
    const hasBeenDelete = await patchCompany({
      id: data?.id,
      data: {
        deleted: 1,
      },
    });

    if ("data" in hasBeenDelete) {
      toast.success(t("toast_deleteCompanyButton_success"));
    } else if ("error" in hasBeenDelete) {
      toast.error(t("toast_deleteCompanyButton_error"));
    }

    setShowModalDelete(false);
    navigate(`/${NAV_PATH.ADMIN}/${NAV_PATH.COMPANIES}`);
  };

  return (
    <>
      <div className="w-100 d-flex justify-content-end px-5 pb-5">
        <Button
          className="btn-secondary"
          onClick={() => setShowModalDelete(true)}
        >
          Usuń firmę
        </Button>
      </div>
      <PopupModal
        titleClasses="fw-600 text-center text-dark-blue"
        text={`Czy na pewno chcesz usunąć firmę wraz z benefitami?`}
        smallText={`firma: ${data?.name}, NIP: ${data?.nipProvider}`}
        type="confirm"
        show={showModalDelete}
        setShow={() => setShowModalDelete(false)}
        confirmAction={() => modalDeleteHandler()}
      />
    </>
  );
};

export default DeleteCompanyButton;
